// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"7223dd83","544":"e39ad9a0","592":"973a88b4","752":"4150d448","832":"6abab715","848":"8c29d66d","932":"0ea4ea13"}[chunkId] + ".chunk.js";
};